const Tabs = () => {
  const containers = Array.from(document.querySelectorAll(".tabs"));

  if (!containers.length) return;

  containers.forEach((container) => {
    const tabOpeners = Array.from(container.querySelectorAll(".tabs__opener"));
    const tabItems = Array.from(container.querySelectorAll(".tabs__item"));

    if (tabOpeners.length > 0) {
      tabOpeners.forEach((item) => {
        item.addEventListener("click", (e) => {
          e.preventDefault();

          tabItems.forEach((item) => {
            item.classList.remove("active");
          });

          tabOpeners.forEach((item) => {
            item.classList.remove("active");
          });

          const target = item.dataset.target;
          const targetEl = tabItems.find((el) => el.dataset.id === target);
          if (targetEl) {
            targetEl.classList.add("active");
            item.classList.add("active");
          }
        });
      });
    }
  });
};

export default Tabs;
